import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';

import { MembershipPlanComponent } from './membership-plan.component';  
import { MembershipModalComponent } from '../membership-modal/membership-modal.component';

@NgModule({
  declarations: [MembershipPlanComponent],
  exports: [MembershipPlanComponent],
  imports: [
    CommonModule,
    ...COMMON_MODULES,
    MembershipModalComponent,
  ]
})
export class MembershipPlanModule {}
